// extracted by mini-css-extract-plugin
export default {"lastSave":"nJh0b","form":"I8bLp","header":"s54Iv","name":"jpqvJ","footer":"HWzRc","export":"ZlXVV","exportText":"kyRa6","actions":"qtmrT","action":"lMSSN"};